import React, { useMemo } from 'react';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../_metronic/_partials/controls';
import { useUserUIContext } from './UserUIContext';
import UserTable from './user-table/UserTable';
import { UserFilter } from "./user-filter/UserFilter";
import { BlockOrg, RoleChecker } from '../../../../RoleChecker';

function UserCard(props) {

    const userUIContext = useUserUIContext();
    const userUIProps = useMemo(() => {
        return {
            newUserButtonClick: userUIContext.newUserButtonClick,
        };
    }, [userUIContext]);

    return (
        <Card>
            <CardHeader title="User List">
                <CardHeaderToolbar>
                    {BlockOrg() && RoleChecker("Create", 'user') && <button
                        type="button"
                        className="btn btn-primary"
                        onClick={userUIProps.newUserButtonClick}
                    >New User
                    </button>}
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <UserFilter />
                <UserTable />
            </CardBody>

        </Card>
    );
}

export default UserCard;
